import React, { useState, useEffect } from 'react'
import '../index.css';
import iconpos from '../../../assets/pos.png';
import iconcheck from '../../../assets/check.png'
import iconchecked from '../../../assets/checked.png'
import { api } from '../../../common/app';
import { Toast } from 'antd-mobile';
import invariant from 'invariant';
import Empty from '../component/empty';
import moment from 'moment';

export default (props: any) => {
  const { id } = props.match.params;

  const [list, setList] = useState([] as any[]);
  const [selectedId, setSelectedId] = useState(-1);

  useEffect(() => {
    if (!!id) {
      (api as any).myMeetingList({ meetid: id })
        .then((result: any) => {
          console.log('result', result);
          setList(result.result)
        })
    }
  }, [id])

  const onChange = () => {
    try {
      invariant(!!selectedId, '请选择要切换的会议');
      const currentItem = list && selectedId && list.find(i => i.meetid === selectedId);
      window.location.href = currentItem.link;
    } catch (error) {
      Toast.fail(error.message)
    }
  }

  const currentItem = list && selectedId && list.find(i => i.meetid === selectedId);

  return (
      <div className="mine-meet-list">
          {list.length > 0 ? (
              <div>
                  {list.map((item) => {
                      return (
                          <div
                              className="mine-meet-card"
                              key={item.meetid}
                              onClick={() => setSelectedId(item.meetid)}
                          >
                              {currentItem &&
                              currentItem.meetid === item.meetid ? (
                                  <div
                                      className="mine-meet-check"
                                      style={{
                                          backgroundImage: `url(${iconchecked})`,
                                      }}
                                  />
                              ) : (
                                  <div
                                      className="mine-meet-check"
                                      style={{
                                          backgroundImage: `url(${iconcheck})`,
                                      }}
                                  />
                              )}
                              <div className="mine-meet-card-pos">
                                  <div
                                      className="mine-meet-card-pos-icon"
                                      style={{
                                          backgroundImage: `url(${iconpos})`,
                                      }}
                                  />
                                  <span style={{ color: "#fff" }}>
                                      {item.city}
                                  </span>
                              </div>
                              <div
                                  className="mine-meet-card-cover"
                                  style={{
                                      backgroundImage: `url(${item.cover})`,
                                  }}
                              />
                              <div className="mine-meet-card-detail">
                                  <span
                                      style={{ maxWidth: 200 }}
                                      className="mine-meet-detail-left"
                                  >
                                      {item.title}
                                  </span>
                                  <span>{`${moment(item.start_time).format('YYYY-MM-DD')} - ${moment(item.end_time).format('YYYY-MM-DD')}`}</span>
                              </div>
                          </div>
                      );
                  })}

                  <div className="mine-meet-button" onClick={onChange}>
                      切换
                  </div>
              </div>
          ) : (
          <div style={{ height: '100%' }}>
            <div style={{ width: '100%', height: '30vh'}} />
                <Empty title ='您还没有参与过的会议'/>
            </div>
          )}
      </div>
  );
}